import { FC } from "react";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useFormik } from "formik";
import * as yup from "yup";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { NoSearchEngineTemplate } from "templates/NoSearchEngineTemplate";
import { ReactComponent as LeftIcon } from "../../images/leftIcon.svg";
import { PublicRoute } from "routers/PublicRoute";
import { fetchForgotPassword } from "services/forgot-password";
export interface PageLoginProps {}

interface InsertEmailProps {
  className?: string;
}

const PageForgotPassword: FC<PageLoginProps> = ({
  className = "",
}: InsertEmailProps) => {
  const navigate = useNavigate();
  const validationSchema = yup.object({
    email: yup
      .string()
      .email("Insira um e-mail válido")
      .required("E-mail é obrigatório"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const res = fetchForgotPassword({ email: values.email });
      toast.promise(
        res,
        {
          loading: "Enviando e-mail...",
          success: () => {
            setTimeout(() => {
              navigate("/form-forgot-password");
            }, 3000);
            return "Enviamos por e-mail o código de recuperação de senha.";
          },
          error: (error) => {
            if (error instanceof Error) {
              toast.error(error.message);
              return error.message;
            }
            return "Tive um erro ao enviar o e-mail. Tente novamente.";
          },
        },
        {
          style: {
            padding: "18px",
            fontSize: "16px",
          },
          success: {
            duration: 8000,
          },
        }
      );
    },
  });

  return (
    <PublicRoute>
      <NoSearchEngineTemplate>
        <button
          className="flex flex-row items-center ml-5 mt-5 cursor-pointer"
          onClick={() => navigate(-1)}
        >
          <LeftIcon style={{ marginRight: "10px" }} />
          <span className="text-xl">Voltar</span>
        </button>
        <div className={`nc-PageLogin ${className}`} data-nc-id="PageLogin">
          <Toaster />
          <div className="container mb-24 lg:mb-32">
            <h2 className="my-10 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
              Insira seu e-mail cadastrado
            </h2>
            <div className="max-w-md mx-auto space-y-6">
              <form
                className="grid grid-cols-1 gap-6"
                onSubmit={formik.handleSubmit}
              >
                <label htmlFor="email" className="block">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    Endereço de e-mail
                  </span>
                  <Input
                    type="email"
                    placeholder="example@example.com"
                    className={`mt-1 mb-1 ${
                      formik.touched.email && formik.errors.email
                        ? "focus:ring-red-500 focus:border-opacity-50 focus:border-red-500 border-red-500"
                        : ""
                    }`}
                    {...formik.getFieldProps("email")}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <div className="text-red-500 text-xs">
                      {formik.errors.email}
                    </div>
                  )}
                </label>
                <div>
                  <span className="flex justify-between items-center text-sm text-center text-neutral-800 dark:text-neutral-200">
                    Será enviado um código de verificação para o e-mail
                    informado.
                  </span>
                </div>
                <ButtonPrimary
                  type="submit"
                  disabled={
                    !formik.isValid ||
                    formik.isSubmitting ||
                    !formik.getFieldProps("email").value
                  }
                  className="bg-[--blue] hover:bg-[--blue-dark] disabled:bg-[#b2d0e0] disabled:cursor-not-allowed"
                >
                  Continue
                </ButtonPrimary>
              </form>
            </div>
          </div>
        </div>
      </NoSearchEngineTemplate>
    </PublicRoute>
  );
};

export default PageForgotPassword;
